"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PriceFormatter = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/PriceFormatter"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles formatting of prices.
 *
 * Deprecated, use @ikea-aoa/ikea-shared-utils/lib/util/PriceFormatter
 */
var PriceFormatterWrapper = /*#__PURE__*/function () {
  function PriceFormatterWrapper() {
    _classCallCheck(this, PriceFormatterWrapper);
  }

  _createClass(PriceFormatterWrapper, null, [{
    key: "format",

    /**
     * Formats a price.
     *
     * @deprecated
     * @param {number} amount Price amount.
     * @param {object} config Configuration to use. Usually recieved from common translations under the "prices" property.
     * @param {number} config.currencyCode Currency code used.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {boolean} config.thousandSeparatorEnabled TRUE to enable thousand separator.
     * @param {string} config.thousandSeparator Thousand separator.
     * @param {boolean} config.replaceNoValueDecimals TRUE to replace no value decimals.
     * @param {string} config.noValueDecimalsString No value decimals string.
     * @param {string} config.decimalSeparator Decimal separator.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {string} config.symbolSpacing Symbol spacing.
     * @param {string} config.currencySymbol Currency symbol.
     * @param {string} config.currencyPosition Currency position ("before" or "after").
     * @param {boolean} [useHtml] TRUE to use HTML. This will add a span with dir="ltr", so that '1 400' wont get reversed in morocco. Default is TRUE.
     * @returns {string} Formatted price with currency.
     */
    value: function format(amount, config) {
      var useHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      _Console.default.warn('PriceFormatter has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/PriceFormatter" instead.');

      return _PriceFormatter.default.format(amount, config, useHtml);
    }
    /**
     * Formats a price to be used for a single article.
     *
     * @deprecated
     * @param {number} amount Price amount.
     * @param {object} config Configuration to use. Usually recieved from common translations under the "prices" property.
     * @param {number} config.currencyCode Currency code used.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {boolean} config.thousandSeparatorEnabled TRUE to enable thousand separator.
     * @param {string} config.thousandSeparator Thousand separator.
     * @param {boolean} config.replaceNoValueDecimals TRUE to replace no value decimals.
     * @param {string} config.noValueDecimalsString No value decimals string.
     * @param {string} config.decimalSeparator Decimal separator.
     * @param {number} config.numberOfDecimals Number of decimals.
     * @param {string} config.symbolSpacing Symbol spacing.
     * @param {string} config.currencySymbol Currency symbol.
     * @param {string} config.currencyPosition Currency position ("before" or "after").
     * @param {object} article An article object returned from ArticleServiceFacade when formatting is done on a single item. Additional information like package information will be added.
     * @param {boolean} [useHtml] TRUE to use HTML. This will add a span with dir="ltr", so that '1 400' wont get reversed in morocco. Default is TRUE.
     * @returns {string} Formatted price with currency.
     */

  }, {
    key: "formatForArticle",
    value: function formatForArticle(amount, config, article) {
      var useHtml = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      _Console.default.warn('PriceFormatter has been deprecated. Use "@ikea-aoa/ikea-shared-utils/lib/util/PriceFormatter" instead.');

      return _PriceFormatter.default.formatForArticle(amount, config, article, useHtml);
    }
  }]);

  return PriceFormatterWrapper;
}();

exports.default = PriceFormatterWrapper;